import { Table } from 'antd';
import $ from 'jquery';
import { showError, showFile } from '../App';


const bytesToHuman = (bytes) => {
  if (!bytes) return '0 B';
  const map = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];  // 映射
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i < map.length) {
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + map[i];
  }else{
    return (bytes / Math.pow(1024, map.length)).toFixed(2) + ' ' + map[map.length - 1];
  }
}

const columns = [
  {
    title: '文件名',
    dataIndex: 'name',
    key: 'name',
    render: (text, record) => {
      if (record.url) {
        return <a href={record.url}>{text}</a>
      } else {
        return text
      }
    },
    width: '30%',
    ellipsis: true,
  },
  {
    title: '文件类型',
    dataIndex: 'type',
    key: 'type',
    width: '5%',
    render: (text) => {
      if (text === 'dir') {
        return <span>文件夹</span>
      } else if (text === 'file') {
        return <span>文件</span>
      }
    },
    ellipsis: true,
  },
  {
    title: '文件大小',
    dataIndex: 'size',
    key: 'size',
    render: text => bytesToHuman(text),
    width: '10%',
    ellipsis: true,
  },
  {
    title: '文件地址',
    dataIndex: 'url',
    key: 'url',
    render: (text, record) => {
      if (record.type === 'file') {
        return <a href={record.url}>{text}</a>
      }
    },
    width: '35%',
    ellipsis: true,
  },
];

const API_ENDPOINT = 'https://api.onedrive.com/v1.0'

const getChildren = (id, path) => {
  const url = `${API_ENDPOINT}/shares/s!${id}/driveItem/`
  if (path === '') {
    path = '/'
  }
  while (path.indexOf('//') !== -1) {
    path = path.replace('//', '/')
  }

  var d = {};
  if (path === '/') {
    $.ajax({
      url: url + 'children',
      type: 'GET',
      dataType: 'json',
      async: false,
      success: (data) => {
        d = data;
      },
      error: (data) => {
        showError(data.responseJSON.error.message)
      }
    });
  } else {
    $.ajax({
      url: (url + ':' + path + ':/children').replace('//', '/'),
      type: 'GET',
      dataType: 'json',
      async: false,
      success: (data) => {
        d = data;
      },
      error: (data) => {
        showError(data.responseJSON.error.message);
      }
    });
  }
  var index = [];
  for (var i = 0; i < d.value.length; i++) {
    index.push({
      name: d.value[i].name,
      type: d.value[i].folder ? 'dir' : 'file',
      size: d.value[i].size,
      url: d.value[i]['@content.downloadUrl'],
      children: d.value[i].folder ? getChildren(id, path + d.value[i].name + '/') : undefined
    })
  }
  return index;
}

const GetById = (id) => {
  const token = id;
  const url = `${API_ENDPOINT}/shares/s!${token}`
  var name = '';
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
    async: false,
    success: (data) => {
      name = data.name;
    },
    error: (data) => {
      showError(data.responseJSON.error.message);
    }
  });
  var d = {};
  $.ajax({
    url: url + '/driveItem',
    type: 'GET',
    dataType: 'json',
    async: false,
    success: (data) => {
      console.log(data)
      d = data;
    },
    error: (data) => {
      showError(data.responseJSON.error.message)
    }
  });
  if (d === {}) {
    showError('获取文件列表失败 (ErrGetFiles)');
  }
  if (d.error) {
    showError('获取文件列表失败 (ErrGetFiles)\n' + d.error);
    return false;
  }
  if (d.file) {
    showFile(
      <Table columns={columns} dataSource={[{
        name: name,
        type: 'file',
        size: bytesToHuman(d.size),
        url: d['@content.downloadUrl']
      }]}
        style={{ width: '100vh' }} />
    )
  }
  if (d.folder) {
    var index = {
      name: name,
      type: 'dir',
      szie: bytesToHuman(d.szie),
      url: '',
      children: getChildren(token, '')
    }
    showFile(
      <Table columns={columns} dataSource={index.children} style={{ width: '100vh' }} />
    )
  }
}

export { GetById };